import React from "react";
import { Component } from "react";
import { Spinner } from "../ui/Spinner";
import { connect } from "react-redux";
import { Link, RouteComponentProps, Redirect } from "react-router-dom";
import { Dispatch } from "redux";
import {
  DocumentTypeResult,
  FileUploadRequest,
  FileUploadResult,
  UpdatePasswordRequest,
  UserInfo,
} from "../http/protocol";
import { LoginStatus, Status } from "../http/Types";
import { getContainer } from "../ioc/IOCSetup";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { AppState } from "../RootReducer";

import { debug } from "console";
import { fileUpload, getDocumentTypes } from "./FileUploadActions";
import "./FileUpload.scss";
import { showAccountVerificationModal } from "../user/UserActions";

import { t } from "../i18n";

interface State {
  file1: File;
  file2: File;
  expiryDate: string;
  documentNumber: string;
  errorMessage: string;
  selectedDocType: DocumentTypeResult;
  showDocumentNumber: boolean;
  showExpiryDate: boolean;
  file2hasFile: boolean;
  file1hasFile: boolean;
}

type AllProps = PropsFromState &
  PropsFromDispatch &
  RouteComponentProps &
  OtherProps;

export class DocumentUploadPage extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);

    this.state = {
      file1: null as any,
      file2: null as any,
      expiryDate: "",
      documentNumber: "",
      errorMessage: null as any,
      selectedDocType: null as any,
      showDocumentNumber: false,
      showExpiryDate: false,
      file1hasFile: false,
      file2hasFile: false,
    };

    this.props.getDocumentTypes && this.props.getDocumentTypes();
  }

  handleFormSubmit = (e: any) => {
    const file = this.state.file1;
    const file2 = this.state.file2;
    var expiryDate = this.state.expiryDate;
    var documentNumber = this.state.documentNumber;
    var documentType = this.state.selectedDocType;

    if (file === null && file2 === null) {
      this.setState({ errorMessage: t("docuUpload.err1") });
    } else if (file2 === null) {
      this.setState({ errorMessage: t("docuUpload.err2") });
    } else if (file === null) {
      this.setState({ errorMessage: t("docuUpload.err3") });
    } else if (file && file2) {
      this.props.fileUpload({
        file: file,
        file2: file2,
        expiryDate: expiryDate,
        documentNumber: documentNumber,
        documentType: t("docuUpload.proofBill"),
      });

      // if (this.props.upload.uploadSuccess) {
      //   this.setState({
      //     expiryDate: "",
      //     documentNumber: "",
      //     file1: null as any,
      //     file2: null as any,
      //     selectedDocType: null as any,
      //   });
      // }
    } else {
      //Error message
    }
  };

  handleUpload = (e: any) => {
    console.log(e.target.files[0]);
    this.setState({ file1: e.target.files[0] as any, errorMessage: "", file1hasFile: true });
  };

  handleUpload2 = (e: any) => {

    console.log(e.target.files[0]);
    this.setState({ file2: e.target.files[0] as any, errorMessage: "", file2hasFile: true });
  };

  handleExpiryDateInput = (e: any) => {
    this.setState({ expiryDate: e.target.value });
  };

  handleDocumentNumberInput = (e: any) => {
    this.setState({ documentNumber: e.target.value });
  };

  handleDocTypeSelect = (e: any) => {
    if (e.target.value != "") {
      var selectedDocType = this.props.documentTypes[e.target.value];
      this.setState({
        selectedDocType: selectedDocType,
        showDocumentNumber: selectedDocType.documentNumberRequired,
        showExpiryDate: selectedDocType.expiryDateRequired,
      });
    }
  };

  render() {
    const docTypes = this.props.documentTypes;
    var selectedType = this.state.selectedDocType;
    if (this.props.fileUploadResult && this.props.fileUploadResult.status === "SUCCESS") {
      return (

        <p>
          <img src={"https://content.adminemx.com/maharajafortune/images/header-icons-v2/account-verification.svg"} className="img-fluid d-block" style={{ width: "200px", display: "block", margin: "10px auto", fill: "#fff", filter: "invert(1)" }} />
          <p dangerouslySetInnerHTML={
            	{ __html: t("docuUpload.text1", { interpolation: { escapeValue: false } })}}>
          </p>
          <button className="btn btn-cta btn-lg mt-4" onClick={() => { this.props.hide && this.props.hide(); }}>{t("docuUpload.close")}</button>
        </p>
      );
    }

    return (
      <React.Fragment>
        {this.props.upload.isFetching ? (
          <Spinner />
        ) : (
          <div className="kycForm">
            {/* <h1>KYC Upload Document</h1> */}
            <p dangerouslySetInnerHTML={
              { __html: t("docuUpload.KYCform", { interpolation: { escapeValue: false } })}}>
             </p>
            {this.state.errorMessage ?
              (<div className="alert alert-danger mt-4">
                {this.state.errorMessage}
              </div>) : null}
            <form id="form-upload-doc">
              <div className="form-group d-flex">
                <div className="row">


                  <div className="col-lg-6 col-12">
                    <div className="upload-container">
                      <label htmlFor="file1">
                      <p dangerouslySetInnerHTML={
                        { __html: t("docuUpload.IDproof", { interpolation: { escapeValue: false } })}}>
                      </p>
                      </label>
                      {this.state.file1hasFile ? (<FontAwesomeIcon icon={faUpload} color="#ff9c00" style={{ margin: "10px auto" }} size="3x" />) : (<FontAwesomeIcon icon={faUpload} color="#4b4b4b" style={{ margin: "10px auto" }} size="3x" />)}
                      <input
                        id="file1"
                        type="file"
                        className={`custom-file-input ${this.state.file1hasFile ? 'hasFile' : ''}`}
                        onChange={this.handleUpload}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-12">
                    <div className="upload-container">
                      <label htmlFor="file2">
                      <p dangerouslySetInnerHTML={
                        { __html: t("docuUpload.Addproof", { interpolation: { escapeValue: false } })}}>
                      </p>
                      </label>
                      {this.state.file2hasFile ? (<FontAwesomeIcon icon={faUpload} color="#ff9c00" style={{ margin: "10px auto" }} size="3x" />) : (<FontAwesomeIcon icon={faUpload} color="#4b4b4b" style={{ margin: "10px auto" }} size="3x" />)}

                      <input
                        id="file2"
                        type="file"
                        className={`custom-file-input ${this.state.file2hasFile ? 'hasFile' : ''}`}
                        onChange={this.handleUpload2}
                      />
                    </div>
                  </div>
                </div>

                {/* 
                <div hidden={!this.state.showExpiryDate}>
                  <label htmlFor="expiryDate">
                    <b>Expiry Date</b>
                  </label>
                  <input
                    id="expiryDate"
                    type="date"
                    className="form-control"
                    onChange={this.handleExpiryDateInput}
                  />
                </div> */}

                <div hidden={!this.state.showDocumentNumber}>
                  <label htmlFor="documentNumber">
                    <p dangerouslySetInnerHTML={
                      { __html: t("docuUpload.IDnum", { interpolation: { escapeValue: false } })}}>
                    </p>
                  </label>
                  <input
                    id="documentNumber"
                    type="text"
                    className="form-control"
                    onChange={this.handleDocumentNumberInput}
                  />
                </div>
              </div>
                {t("docuUpload.text2")}
              <button
                type="button"
                className="btn btn-primary btn-block"
                onClick={() => this.handleFormSubmit(this.props)}
              >
                {t("submit")}
              </button>
              {t("docuUpload.text3")}
            </form>
          </div>
        )}
      </React.Fragment>

    );
  }
}

interface OtherProps extends RouteComponentProps { }

interface PropsFromState {
  loggedIn: boolean;
  user?: UserInfo;
  lng: string;
  documentTypes: DocumentTypeResult[];
  upload: any;
  fileUploadResult?: any;
  hide?: () => void;
  //updatePassword: typeof updatePassword
}

interface PropsFromDispatch {
  fileUpload: (request: FileUploadRequest) => any;
  getDocumentTypes: () => DocumentTypeResult[];
  //password: PasswordState;
}

const mapStateToProps = ({
  user,
  contentful,
  password,
  fileUpload,
}: AppState) => {
  let status = false;


  return {
    user: user.user,

    lng: getContainer().getSettingsService().getActiveLocale().code,
    loggedIn: LoginStatus.LOGGED_IN == user.status,
    documentTypes: fileUpload.documentTypes,
    upload: fileUpload,
    fileUploadResult: fileUpload.result
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fileUpload: (request: FileUploadRequest) => dispatch(fileUpload(request) as any),
  getDocumentTypes: () => dispatch(getDocumentTypes() as any),
  hide: () => { dispatch(showAccountVerificationModal(false)) },
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentUploadPage);
